import { render, staticRenderFns } from "./SideVideoCard.vue?vue&type=template&id=ebe7e404&scoped=true"
import script from "./SideVideoCard.vue?vue&type=script&lang=js"
export * from "./SideVideoCard.vue?vue&type=script&lang=js"
import style0 from "./SideVideoCard.vue?vue&type=style&index=0&id=ebe7e404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe7e404",
  null
  
)

export default component.exports